/**
 * Task status constants that match the backend TaskStatus enum
 */
export const TaskStatus = {
    PENDING: "pending",
    PROCESSING: "processing",
    COMPLETE: "complete",
    FAILED: "failed",
    ERROR: "error"
};

/**
 * Task status display names for UI
 */
export const TaskStatusDisplayNames = {
    [TaskStatus.PENDING]: "Pending",
    [TaskStatus.PROCESSING]: "Processing",
    [TaskStatus.COMPLETE]: "Complete",
    [TaskStatus.FAILED]: "Failed",
    [TaskStatus.ERROR]: "Error"
};
